var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 2.75h16.5c.506 0 .917.41.917.917v14.666c0 .507-.41.917-.917.917H2.75a.917.917 0 0 1-.917-.917V3.667c0-.507.41-.917.917-.917zm15.583 3.885-7.267 6.508-7.4-6.528v10.802h14.667V6.635zM4.135 4.583l6.92 6.107 6.822-6.107H4.135z",
    fill: "#222",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.ec7a7f509a2ca4265623d5990fc0af98.svg";
export { ForwardRef as ReactComponent };